/* eslint-disable no-dupe-keys */

export function getPageInfo(url) {
  const config = {
    'homepage/stepone': {
      pageType: 'kit_adjustment_1/5_1',
      pageName: '1/5柜型尺寸选择_形状',
    },
    'homepage/steptwo': {
      pageType: 'kit_adjustment_1/5_2',
      pageName: '1/5柜型尺寸选择_尺寸',
    },
    'homepage/stepthree': {
      pageType: 'kit_adjustment_1/5_3',
      pageName: '1/5柜型尺寸选择_位置',
    },
    'home/doorPlank': {
      pageType: 'kit_adjustment_2/5',
      pageName: '2/5门板选择',
    },
    'home/mesa': {
      pageType: 'kit_adjustment_3/5',
      pageName: '3/5台面选择',
    },
    'home/storage': {
      pageType: 'kit_adjustment_4/5',
      pageName: '4/5内配储物',
    },
    'home/offer': {
      pageType: 'kit_offer',
      pageName: '5/5报价',
    },
  };
  const key = Object.keys(config).find((item) => url.includes(item));
  return key ? config[key] : {
    pageType: '-',
    pageName: '-',
  };
}

export function GIO(type, params) {
  const pageInfo = getPageInfo(window.location.href);
  window.gio('track', type, {
    platform_var: localStorage.getItem('gioPlatform'),
    pageType_var: pageInfo.pageType,
    pageName_var: pageInfo.pageName,
    pageId_var: window.location.href,
    ...params,
  });
}
const pageLoadInfo = 'PAGE_LOAD_INFO';

export function setPageStart(pathname) {
  window.sessionStorage(pageLoadInfo, JSON.stringify({
    startTime: new Date().getTime(),
    pathname,
  }));
}


export const GIOImpression = (params, dom, id, once = true) => {
  let isExecuteOnce = false;
  const intersectionObserver = new IntersectionObserver((entries) => {
    if (once && isExecuteOnce) return;
    if (entries[0] && entries[0].intersectionRatio <= 0) return;
    GIO('impressionData', { eventType_var: 'impression', ...params });
    isExecuteOnce = true;
  });
  intersectionObserver.observe(dom);
};
